import { connect } from 'react-redux';
import OrderSearchPage from 'src/components/custom/OrderSearch';
import { IStoreState } from 'src/entity/StateEntity';

const mapStateToProps = ({ userState: { isAgent }, drugStoreState: { drugStores } }: IStoreState) => ({
  isAgent,
  drugStores,
});

export default connect(mapStateToProps)(OrderSearchPage);



// WEBPACK FOOTER //
// ./src/containers/OrderSearch.ts